// startup
// Load entry module and return exports
// This entry module is referenced by other modules so it can't be inlined
__webpack_require__("./node_modules/es6-promise/dist/es6-promise.js");
__webpack_require__("./node_modules/es6-shim/es6-shim.js");
__webpack_require__("./node_modules/event-source-polyfill/src/eventsource.js");
var __webpack_exports__ = __webpack_require__("./node_modules/jquery/dist/jquery.js");
